<template>
    <div>
        <b-modal
            :visible="visible"
            id="admin-permission-modal"
            size="lg"
            :ok-title="`${permission ? 'Edit' : 'Add'} Permission`"
            :ok-disabled="!validated && !saving"
            @cancel="cancel"
            @close="cancel"
            @ok.prevent="save"
            @hidden="reset"
            no-close-on-esc
        >
            <template #modal-title>
                <span v-if="permission">Edit</span>
                <span v-else>Add</span>
                Permission
            </template>

            <b-form-group label="Name" label-for="permission-modal-name">
                <b-form-input
                    id="permission-modal-name"
                    type="text"
                    placeholder="Enter Name"
                    aria-label="name"
                    v-model="permission_name"
                    :state="validated"
                    required
                />
                <b-form-invalid-feedback :state="validated" v-if="!saving">
                    {{ invalidFeedback }}
                </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group label-for="permission-modal-roles">
                <template #label>
                    Roles
                    <b-button id="role-modal-permissions-tip" variant="link" class="p-0">
                        <font-awesome-icon :icon="['fad', 'info-circle']" />
                    </b-button>
                    <b-tooltip target="role-modal-permissions-tip" triggers="hover">
                        (Optional) Roles to assign to the permission, upon creation/modification.
                    </b-tooltip>
                </template>

                <multiselect
                    id="permission-modal-roles"
                    v-model="selected_roles"
                    placeholder="Select Roles"
                    label="name"
                    track-by="id"
                    :options="roles"
                    :multiple="true"
                />
            </b-form-group>
        </b-modal>
    </div>
</template>

<style></style>

<script>
import { mapState } from 'vuex'
import moment from 'moment'

export default {
    data: () => ({
        permission_name: '',
        saving: false,
        selected_roles: null,
    }),
    props: {
        visible: Boolean,
        permission: Object,
    },
    components: {

    },
    computed: {
        ...mapState({
            errors: state => state.errors.errors,
            user: state => state.user.user,
            roles: state => state.admin.roles,
            permissions: state => state.admin.permissions,
        }),
        invalidFeedback() {
            if (!this.nameIsSet) {
                return 'Enter a name'
            }
            if (this.nameIsDuplicated) {
                return 'Name already exists'
            }
        },
        validated() {
            return this.nameIsSet && this.nameIsDuplicated === false
        },
        nameIsSet() {
            return this.permission_name.length !== 0
        },
        nameIsDuplicated() {
            const nameAlreadyExists = this.permissionNames.includes(this.permission_name)
            if (this.permission) {
                return this.permission.name !== this.permission_name && nameAlreadyExists
            }

            return nameAlreadyExists
        },
        permissionNames() {
            return this.permissions.map(permission => permission.name)
        }
    },
    methods: {
        cancel() {
            this.$emit('hide')
        },
        async save() {
            try {
                this.saving = true
                const permissionData = {
                    name: this.permission_name,
                    roles: this.selected_roles,
                }

                if (!this.permission) {
                    await this.$store.dispatch('createAdminPermission', permissionData)
                } else {
                    await this.$store.dispatch('updateAdminPermission', {
                        ...permissionData,
                        id: this.permission.id,
                    })
                }
                // reload the stores that would be updated
                await this.$store.dispatch('getAdminPermissions')
                await this.$store.dispatch('getAdminRoles')

                this.$emit('hide')
            } catch (e) {
                await this.$store.dispatch('pushError', {
                    data: {
                        message: `Failed to save permission: ${e.message}`,
                    },
                    time: moment().toISOString(),
                })
            }
        },
        reset() {
            this.saving = false

            if (!this.permission) {
                this.permission_name = ''
                this.selected_roles = null
            } else {
                this.permission_name = this.permission.name
                this.selected_roles = this.permission.roles
            }
        },
    },
    mounted() {
        this.$root.$on('bv::modal::show', (bvEvent, modalId) => {
            if (modalId !== 'admin-permission-modal') {
                return
            }

            this.reset()
        })
    }
}
</script>
